module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('bloco', {
    staticClass: "-padding-desktop",
    attrs: {
      "id": "sitemap"
    }
  }, [_c('header', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('titulo', {
    staticClass: "-withbar -upper"
  }, [_vm._v("Unidades")]), _c('p', [_vm._v("A PROAD é constituída pelas seguintes unidades:")])], 1), _c('div', {
    staticClass: "conteudo",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('ul', {
    staticClass: "listagem lista"
  }, [_c('li', {
    staticClass: "item"
  }, [_vm._v("Assessoria Técnica – ASTEC")]), _c('li', {
    staticClass: "item"
  }, [_vm._v("Coordenadoria Administrativa – CA")]), _c('li', {
    staticClass: "item"
  }, [_vm._v("Coordenadoria de Transportes – CGT")]), _c('li', {
    staticClass: "item"
  }, [_vm._v("Coordenadoria de Convênios – CC")]), _c('li', {
    staticClass: "item"
  }, [_vm._v("Coordenadoria de Gestão de Espaços Físicos – CGEF")]), _c('li', {
    staticClass: "item"
  }, [_vm._v("Coordenadoria de Gestão da Informação – CGI")]), _c('li', {
    staticClass: "item"
  }, [_vm._v("Diretoria de Contabilidade e Finanças – DCF")]), _c('li', {
    staticClass: "item"
  }, [_vm._v("Diretoria de Contratos – DC")]), _c('li', {
    staticClass: "item"
  }, [_vm._v("Diretoria de Logística – DL")]), _c('li', {
    staticClass: "item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'DCOMIndex'
      }
    }
  }, [_vm._v("Diretoria de Compras – DCOM")])], 1), _c('li', {
    staticClass: "item"
  }, [_vm._v("Diretoria de Segurança Patrimonial – DSP")])]), _c('p', [_vm._v("Clique no nome da unidade para visitar a sua seção.")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4437e08e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/modules/Unidades.vue
// module id = 484
// module chunks = 0